// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"64":"af9f72bf","136":"1bcf58e3","165":"fd4dd040","507":"f3e526d6","544":"8a69514f","645":"f1662e97"}[chunkId] + ".css";
};